export default "__VITE_ASSET__BXVq8mnP__"